// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chameleon .relative_link_wrapper{max-width:45em}`, "",{"version":3,"sources":["webpack://./chameleon/legacy/src/components/content/types/media/relative_link.scss"],"names":[],"mappings":"AAAA,kCACE,cAAA","sourcesContent":[".relative_link_wrapper {\n  max-width: 45em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
